import React from 'react';
import { Flex, Text, Icon } from '@spothero/ui';
import IconStar from '@spothero/icons/star-filled';
import { getNumberOfReviews } from 'common/star-rating-with-category/StarRatingWithCategory';
import { ReviewTooltip } from './ReviewTooltip';
export const RatingSummary = ({ rating, count }) => {
    return (<Flex data-testid="RatingSummary" marginTop={1} alignItems="center">
            <Icon as={IconStar} color="black" height={4} width={4} marginRight={0.5}/>
            <Text paddingRight={1} fontWeight="semibold" data-testid="RatingSummary-StarRating">
                {rating.toFixed(1)}
            </Text>
            <Text fontSize="sm" color="gray.medium" paddingX={1}>
                |
            </Text>
            <Text fontSize="sm" fontWeight="semibold" data-testid="RatingSummary-Reviews" marginRight={1}>
                {getNumberOfReviews(count)} ratings
            </Text>
            <ReviewTooltip ariaLabel="Rating information">
                After your reservation ends, you can rate your experience from
                1–5 stars. You have 30 days to submit a rating, and your score
                is averaged with other drivers&apos; ratings to determine the
                location&apos;s overall rating.
            </ReviewTooltip>
        </Flex>);
};
